import { observer } from 'mobx-react';
import { DelinquencyStatusForm } from './DelinquencyStatusForm';
import type { DelinquencyConstants } from './delinquencyConstants';
import { CustomTaskDialog } from '@roc/feature-general-tasks';
import { StandardDialog } from '@roc/ui';
import { Document as DocumentType } from '@roc/feature-types';

export type DelinquencyStatusItemProps = {
  open: boolean;
  onClose: () => void;
  loanId?: string;
  loanDocument?: Record<string, unknown>;
  statusValues?: DelinquencyConstants;
  document?: DocumentType;
};

export const DelinquencyStatusItem = observer(
  ({ open, onClose, loanId, statusValues, loanDocument, document }: DelinquencyStatusItemProps) => {
    const dialogContent = (
      <DelinquencyStatusForm
        handleClose={onClose}
        loanId={loanId != null ? Number(loanId) : undefined}
        loanDocument={loanDocument}
        statusValues={statusValues}
      />
    );

    return (
      <>
        {document?.taskId ? (
          <CustomTaskDialog
            open={open}
            title="Delinquency Status And Comments"
            handleClose={onClose}
            dialogContent={dialogContent}
            taskId={document.taskId}
          />
        ) : (
          <StandardDialog
            open={open}
            title="Delinquency Status And Comments"
            maxWidth="sm"
            handleClose={onClose}
            dialogContent={dialogContent}
          />
        )}
      </>
    );
  }
);

export default DelinquencyStatusItem;
